export default function(store) {
  return store.getters['auth/IS_AUTH'] && (
    store.getters['auth/ROLE_NAME'] == 'pre-selection-ai_tech' || 
    store.getters['auth/ROLE_NAME'] == 'pre-selection-agrtech' || 
    store.getters['auth/ROLE_NAME'] == 'pre-selection-digitmed' || 
    store.getters['auth/ROLE_NAME'] == 'pre-selection-fintech' || 
    store.getters['auth/ROLE_NAME'] == 'pre-selection-smartcity'
  );
};